export const ar = {
  loading: "جاري التحميل...",
  retry: "إعادة المحاولة",
  cancel: "إلغاء",
  continue: "متابعة",
  back: "السابق",
  next: "التالي",
  emptyStateTitle: "لا يوجد عناصر في سلة التسوق",
  unknownProduct: "منتج غير معروف",
  productImageAlt: "صورة المنتج",
  emptyStateDescription: "يبدو أن سلة التسوق فارغة. أضف بعض العناصر للبدء!",

  checkout: "الدفع",
  orderSummary: "ملخص الطلب",
  total: "المجموع",
  subtotal: "المجموع الفرعي",
  tax: "الضريبة",
  taxAmount: "مبلغ الضريبة",
  discount: "الخصم",
  agreeToTerms: "أنا موافق على",
  termsAndConditionsLink: "الشروط والأحكام",
  depositAmount: "مبلغ العربون",
  fee: "الرسوم",
  amountToBePaid: "المبلغ المراد دفعه",

  payment: "الدفع",
  paymentMethod: "طريقة الدفع",
  cardNumber: "رقم البطاقة",
  expiryDate: "تاريخ الانتهاء",
  cvv: "رمز الأمان",

  orderConfirmed: "تم تأكيد الطلب",
  orderNumber: "رقم الطلب",
  thankYou: "شكراً لك على طلبك!",

  required: "هذا الحقل مطلوب",
  invalidEmail: "يرجى إدخال عنوان بريد إلكتروني صحيح",
  invalidPhone: "يرجى إدخال رقم هاتف صحيح",
  invalidCard: "يرجى إدخال رقم بطاقة صحيح",
  termsRequired: "يجب أن تقبل الشروط والأحكام لإتمام الطلب",

  paymentMethods: {
    creditCard: "بطاقة ائتمان",
    applePay: "آبل باي",
    bankTransfer: "حوالة بنكية",
    tamara: "تمارا",
    tabby: "تابي",
    noMethodsAvailable: "لا توجد طرق دفع متاحة",
    cashOnDelivery: "الدفع عند الاستلام",
    payLater: "ادفع لاحقًا",
    confirmBooking: "تأكيد الحجز",
    confirmSubscription: "تأكيد الاشتراك",
    completeOrder: "إكمال الطلب"
  },

  bankTransfer: {
    noAccountsAvailable: "لا توجد حسابات بنكية متاحة",
    contactSupport:
      "الرجاء التواصل مع الدعم الفني لإعداد خاصية الدفع عبر التحويل البنكي",
    selectBank: "اختر الحساب البنكي",
    loadingAccounts: "جارٍ تحميل الحسابات البنكية...",
    transferDetails: "تفاصيل التحويل",
    bankName: "اسم البنك",
    holderName: "اسم حامل الحساب",
    accountNumber: "رقم الحساب",
    iban: "الآيبان",
    transferorName: "اسم المحوِّل",
    transferorNamePlaceholder: "أدخل اسمك بالضبط كما يظهر في حسابك البنكي",
    uploadReceipt: "رفع إيصال الحوالة",
    error: {
      title: "تعذر تحميل الحسابات البنكية",
      generic: "يرجى المحاولة مرة أخرى لاحقًا",
      paymentFailed: "فشل الدفع"
    }
  },

  bank: {
    1: "البنك الأهلي السعودي",
    2: "البنك السعودي الأول",
    3: "البنك السعودي للاستثمار",
    4: "بنك الإنماء",
    5: "البنك السعودي الفرنسي",
    6: "بنك الرياض",
    7: "مصرف الراجحي",
    8: "البنك العربي الوطني",
    9: "بنك البلاد",
    10: "بنك الجزيرة",
    11: "بنك الخليج الدولي"
  },

  text: {
    copied: "تم نسخ {{ label }} إلى الحافظة",
    copyFailed: "فشل النسخ إلى الحافظة"
  },

  discountCode: {
    label: "رمز الخصم",
    apply: "تطبيق",
    placeholder: "أدخل رمز الخصم",
    remove: "إزالة",
    applied: "تم تطبيق الخصم"
  },

  orderSummaryStrings: {
    subtotalItems: "عناصر"
  },

  paymentForm: {
    secureEncrypted: "جميع المعاملات آمنة ومشفرة.",
    cardNumberPlaceholder: "رقم البطاقة",
    expiryDatePlaceholder: "تاريخ الانتهاء (MM / YY)",
    securityCodePlaceholder: "رمز الأمان",
    nameOnCardPlaceholder: "الاسم على البطاقة",
    accountHolderPlaceholder: "اسم صاحب الحساب",
    selectBank: "اختر البنك",
    chooseBankPlaceholder: "اختر البنك الخاص بك",
    dropImageHere: "اسقط الصورة هنا",
    dragDropText: "اسحب وأسقط صورة هنا، أو انقر للاختيار",
    fileFormats: "PNG، JPG، GIF حتى 10 ميجابايت",
    clickToReplace: "انقر أو اسحب للاستبدال",
    tamaraDescription: "قسم على 4 دفعات، بدون فوائد",
    tabbyDescription: "ادفع كاملاً أو على أقساط",
    secureNote: "آمن ومشفر",
    processing: "جاري المعالجة...",
    payNow: "ادفع الآن",
    bookingNotes: "ملاحظات الطلب",
    bookingNotesPlaceholder: "ملاحظات الطلب (اختياري)",
    cashOnDeliveryNote: "ستدفع عند استلام طلبك.",
    invalidCreditCard: "يرجى إدخال بيانات بطاقة ائتمان صالحة",
    quickPayment: "الدفع السريع",
    or: "أو"
  },

  upload: {
    error: {
      maxFileUpload: "الحد الأقصى لحجم الملف هو {{maxFileCount}} ميجابايت.",
      invalidFileType:
        "نوع الملف غير مدعوم. يرجى تحميل صورة بصيغة PNG أو JPG أو GIF.",
      singleFileUpload: "يرجى تحميل ملف واحد فقط"
    }
  },

  creditCardForm: {
    emptyCardNumber: "الرجاء إدخال رقم البطاقة.",
    invalidCardNumber: "رقم البطاقة المُدخل غير صالح.",
    emptyExpiryDate: "الرجاء إدخال تاريخ انتهاء الصلاحية.",
    monthOutOfRange: "يجب أن يكون شهر انتهاء الصلاحية بين 01 و 12.",
    yearOutOfRange: "لا يمكن أن تكون سنة انتهاء الصلاحية في الماضي.",
    dateOutOfRange: "لا يمكن أن يكون تاريخ انتهاء الصلاحية في الماضي.",
    invalidExpiryDate: "تاريخ انتهاء الصلاحية المُدخل غير صالح.",
    emptyCVC: "الرجاء إدخال رمز التحقق (CVC).",
    invalidCVC: "رمز التحقق (CVC) المُدخل غير صالح.",
    invalidZipCode: "الرمز البريدي المُدخل غير صالح.",
    cardExpired: "هذه البطاقة منتهية الصلاحية.",
    nameOnCardPlaceholder: "الاسم على البطاقة",
    cardNumberPlaceholder: "رقم البطاقة",
    expiryDatePlaceholder: "تاريخ الانتهاء (MM / YY)",
    securityCodePlaceholder: "رمز الأمان",
    nameRequired: "الاسم مطلوب",
    nameMinLength: "طول الاسم أقل من حرفين",
    nameInvalidChars: "الاسم يحتوي علي حروف غير مدعومة"
  },

  error: {
    title: "حدث خطأ ما"
  },

  creditCardValidations: {
    cardNumberRequired: "الرجاء إدخال رقم البطاقة",
    cardNumberLength: "يجب أن يتكون رقم البطاقة من 13 إلى 19 رقمًا",
    cardNumberInvalid: "الرجاء إدخال رقم بطاقة صحيح",

    nameOnCardRequired: "الرجاء إدخال الاسم على البطاقة",
    nameOnCardMinLength: "يجب ألا يقل الاسم عن حرفين",
    nameOnCardInvalid: "الاسم يمكن أن يحتوي فقط على حروف، مسافات، نقاط، وشرطات",

    expiryMonthRequired: "الرجاء إدخال شهر انتهاء الصلاحية",
    expiryMonthInvalid: "الرجاء إدخال شهر صحيح (MM)",
    expiryYearRequired: "الرجاء إدخال سنة انتهاء الصلاحية",
    expiryYearInvalid: "الرجاء إدخال سنة صحيحة (YY)",

    cvcRequired: "الرجاء إدخال رمز CVC",
    cvcInvalid: "الرجاء إدخال رمز CVC صحيح (3 أو 4 أرقام)",

    cardExpired: "هذه البطاقة منتهية الصلاحية",

    transferorNameRequired: "الرجاء إدخال اسم المحوِّل",
    transferorNameMinLength: "يجب ألا يقل اسم المحوِّل عن حرفين",

    bankReceiptRequired: "الرجاء تحميل إيصال التحويل البنكي",

    phoneNumberInvalid: "الرجاء إدخال رقم هاتف صحيح",

    couponCodeRequired: "الرجاء إدخال رمز القسيمة",
    couponCodeMinLength: "رمز القسيمة لا يمكن أن يكون فارغًا",
    couponCodeMaxLength: "يجب أن يكون رمز القسيمة أقل من 50 حرفًا",

    acceptTOS: "عليك الموافقة على الشروط والأحكام",
    termsAndConditions: "الشروط والأحكام",
    close: "اغلاق"
  }
} as const;
